import 'babel-polyfill'  //低版本浏览器兼容es6,必须在最顶部
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'  // global css
import './icons'
import './utils/request'
import { City } from './assets/js/city.js'
import './permission' // permission control
import global from '@/assets/js/global.js' //
import md5 from 'js-md5'
import lodash from 'lodash'
import VueUeditorWrap from 'vue-ueditor-wrap'
import * as filterArr from '@/assets/js/filters'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload,{
  error:require('./assets/images/bannner-placeholder.jpg')
})
Object.keys(filterArr).forEach(key=>{
  Vue.filter(key, filterArr[key])
})

import goodsImg from '@/assets/images/goods_img.png'
Vue.prototype.$goodsImg = goodsImg
Vue.prototype._ = lodash
Vue.prototype.$City = City
Vue.prototype.$global = global
Vue.prototype.$md5 = global
import apiList from '@/utils/apiList'
Vue.prototype.$api = apiList;
/*import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'*/
/*自定义组件*/
import AdvancedSearch from '@/components/AdvancedSearch/index'  //高级搜索
import Echarts from '@/components/echarts/index'  //Echart
import Search from '@/components/Search/index.vue'  //快捷搜索
import Member from '@/components/Member/index'  //新增、修改用户
import temp from '@/components/temp/index'  //新增、修改用户
import city from '@/components/City/city.vue'  //城市选择
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: (el, {value}) => {
    if (value) {
      el.firstElementChild.focus()
    }
  },
})
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.component('Search', Search)
Vue.component('advanced-search', AdvancedSearch)
Vue.component('Echarts', Echarts)
Vue.component('member', Member)
Vue.component('temp', temp)
Vue.component('city', city)
Vue.use(ElementUI)
Vue.config.devtools = true //开启devtools调试
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  methods: {
    /*    getBroswer () {
          /!** 浏览器类型和版本信息 **!/
          var browser = {
            versions: function () {
              var u = navigator.userAgent, app = navigator.appVersion
              return { //移动终端浏览器版本信息
                trident: u.indexOf('Trident') > -1, //IE内核
                isEdge: u.indexOf('Edge') > -1,//判断是否IE的Edge浏览器
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*!/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                weiXin: u.match(/MicroMessenger/i) == 'MicroMessenger'
              }
            }(),
            language: (navigator.browserLanguage || navigator.language).toLowerCase()
          }
          if (browser.versions.trident || browser.versions.isEdge) {
            alert('IE浏览器不兼容，建议更换浏览器再访问！')
          }
        }*/
  },
  mounted () {
    // this.getBroswer()
  }
})



// WEBPACK FOOTER //
// ./src/main.js